import { useState } from 'react';
import { X, Image as ImageIcon, Trash2 } from 'lucide-react';
import MediaPickerModal from '../MediaPickerModal';
import NahratMedia from '../NahratMedia';
import { ICON_MAP, ICON_KEYS } from './RecipeKatIcon';

// Výběr ikony pro položku — Lucide ikona nebo obrázek z knihovny.
// onPick({ ikona, foto_url }) — nastavuje jedno, druhé nuluje.
export default function IconPickerModal({ open, onClose, current, onPick, isDark }) {
    const [mediaOpen, setMediaOpen] = useState(false);
    if (!open) return null;

    const border = isDark ? 'rgba(255,255,255,0.10)' : 'var(--border-default)';
    const muted = isDark ? 'rgba(255,255,255,0.4)' : 'rgba(0,0,0,0.4)';
    const accent = '#F59E0B';

    return (
        <>
            <div style={{ position: 'fixed', inset: 0, zIndex: 1100, display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'rgba(0,0,0,0.5)', backdropFilter: 'blur(4px)' }}
                onClick={e => { if (e.target === e.currentTarget) onClose(); }}>
                <div style={{ width: 420, maxWidth: '95vw', maxHeight: '80vh', borderRadius: 12, display: 'flex', flexDirection: 'column', overflow: 'hidden',
                    background: isDark ? 'rgba(24,22,32,0.92)' : 'rgba(255,255,255,0.94)',
                    backdropFilter: 'blur(28px) saturate(1.4)', WebkitBackdropFilter: 'blur(28px) saturate(1.4)',
                    border: `1px solid ${isDark ? 'rgba(255,255,255,0.12)' : 'rgba(0,0,0,0.08)'}`, boxShadow: '0 24px 64px rgba(0,0,0,0.4)' }}>
                    <div className="flex items-center justify-between p-4" style={{ borderBottom: `1px solid ${border}` }}>
                        <h3 className="text-sm font-semibold" style={{ color: 'var(--text-primary)' }}>Ikona položky</h3>
                        <button onClick={onClose} style={{ background: 'none', border: 'none', cursor: 'pointer', color: muted }}><X size={18} /></button>
                    </div>

                    <div className="p-4 overflow-y-auto">
                        {/* Nahrání z počítače je hlavní cesta — knihovna zůstává
                            pro případ, že se má použít už nahraná fotka. */}
                        <NahratMedia isDark={isDark} accept="image/*"
                            popisek="Přetáhni sem fotku nebo ji vyber z počítače"
                            onNahrano={(soubor) => {
                                const cesta = soubor?.thumbnail_cesta || soubor?.cesta;
                                if (cesta) { onPick({ foto_url: `/storage/${cesta}`, ikona: null }); onClose(); }
                            }} />

                        <div className="flex items-center gap-2 mt-2 mb-3">
                            <button onClick={() => setMediaOpen(true)}
                                className="flex items-center gap-1.5 px-3 py-2 rounded-lg text-xs font-medium flex-1 justify-center"
                                style={{ background: 'none', color: '#0CC0DF', border: `1px solid ${border}`, cursor: 'pointer' }}>
                                <ImageIcon size={14} /> Vybrat z knihovny
                            </button>
                            {(current?.ikona || current?.foto_url) && (
                                <button onClick={() => { onPick({ ikona: null, foto_url: null }); onClose(); }}
                                    className="flex items-center gap-1.5 px-3 py-2 rounded-lg text-xs font-medium"
                                    style={{ background: 'none', color: '#EF4444', border: `1px solid ${border}`, cursor: 'pointer' }}>
                                    <Trash2 size={14} /> Odebrat
                                </button>
                            )}
                        </div>

                        <p className="text-[11px] mb-2" style={{ color: muted }}>Nebo vyberte ikonu:</p>
                        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(6, 1fr)', gap: 8 }}>
                            {ICON_KEYS.map(key => {
                                const Icon = ICON_MAP[key];
                                const isActive = current?.ikona === key && !current?.foto_url;
                                return (
                                    <button key={key} onClick={() => { onPick({ ikona: key, foto_url: null }); onClose(); }}
                                        className="rounded-lg flex items-center justify-center"
                                        style={{ aspectRatio: '1', background: isActive ? 'rgba(245,158,11,0.15)' : (isDark ? 'rgba(255,255,255,0.04)' : 'rgba(0,0,0,0.03)'), border: `1px solid ${isActive ? accent : border}`, cursor: 'pointer' }}>
                                        <Icon size={20} style={{ color: isActive ? accent : 'var(--text-primary)' }} />
                                    </button>
                                );
                            })}
                        </div>
                    </div>
                </div>
            </div>

            <MediaPickerModal open={mediaOpen} onClose={() => setMediaOpen(false)} accept="image/*"
                onSelect={(id, f) => {
                    const url = f?.thumbnail_cesta || f?.cesta;
                    if (url) { onPick({ foto_url: `/storage/${url}`, ikona: null }); onClose(); }
                }} />
        </>
    );
}
